import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
export class LayoutService {

    pageTitle = new BehaviorSubject<string>('');
    topProgressBar = new BehaviorSubject<boolean>(false);
    lockScroll = new BehaviorSubject<boolean>(false);
    sidebarOpen = new BehaviorSubject<boolean>(true);
    closeOverlay = new BehaviorSubject<boolean>(false);
    showNotification = new BehaviorSubject<boolean>(false);
constructor() {
        this.closeOverlay.subscribe((res) => {
            if (res) {
                this.closeOverlay.next(false);
            }
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LayoutService_tsickle_Closure_declarations() {
/** @type {?} */
LayoutService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LayoutService.ctorParameters;
/** @type {?} */
LayoutService.prototype.pageTitle;
/** @type {?} */
LayoutService.prototype.topProgressBar;
/** @type {?} */
LayoutService.prototype.lockScroll;
/** @type {?} */
LayoutService.prototype.sidebarOpen;
/** @type {?} */
LayoutService.prototype.closeOverlay;
/** @type {?} */
LayoutService.prototype.showNotification;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
